import { MetricTypes } from '@liquitics/transaction';
import { TrendMetric } from './../trend-metric/trend-metric';
export class BalanceMetric extends TrendMetric {
    currency: string;
    balance: number;
    index: number;
    constructor(metricType: string, index: number) {
        super(metricType, 'balance');
        this.index = index;
    }

    createTileKey(): string {
        return TrendMetric.toTileKey(String(this.index), this.metricType);
    }
}
